export const vh = (length: number) => `calc(${length} * min(1.25vw, 0.85vh))`;

export const repeatShadow = (color: string, length: number, precision = 1): string => {
  let offset = 0;
  const shadows: string[] = [];
  while (offset < length) {
    offset += precision;
    shadows.push(`-${offset}px ${offset}px ${color}`);
  }
  return shadows.join(', ');
};
